module.exports = __webpack_public_path__ + "img/thumb1.6c5b511e.png";